import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { Route, Switch, useLocation } from 'react-router-dom';
import InstallDesktopAppBanner from 'flow/companion/InstallDesktopAppBanner';
import CompanionRoleLostNotifier from 'flow/components/CompanionRoleLostNotifier';
import CrmFeatureNotifier from 'flow/components/CrmFeatureNotifier';
import UpdateNotifier from 'flow/components/electron/UpdateNotifier';
import MicPermissionNotifier from 'flow/components/MicPermissionNotifier';
import CompanionRequiredNotifier from 'flow/components/CompanionRequiredNotifier';
import CompanionHeartbeat from 'flow/companion/CompanionHeartbeat';
import GeoLocationNotifier from 'flow/components/GeoLocationNotifier';
import NetworkLostNotifier from 'flow/components/NetworkLostNotifier';
import NotificationPermissionNotifier from 'flow/components/NotificationPermissionNotifier';
import SettingsOnBehalfNotifier from 'flow/components/SettingsOnBehalfNotifier';
import AppToolbar from 'flow/components/ui-components/AppToolbar';
import UnableToPlayAudioNotifier from 'flow/components/UnableToPlayAudioNotifier';
import useAppContext from 'flow/hooks/useAppContext';
import {
    getShowCrmIntegrationFeatureBanner,
    getShowNotificationsGrantedBanner,
} from 'flow/selectors/cti-integration-selectors';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { routes } from 'flow/types/routes';

import { isExtensionKey } from 'flow/utils';
import {
    calculateSelectedTab,
    isMobileApp,
    isTeamsTypeIntegration,
} from 'flow/utils/app-utils';
import Windows10Warning from 'flow/components/Windows10Warning';

const MainHeader = () => {
    const { embedded } = useAppContext();
    const location = useLocation();
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);

    const showCrmIntegrationFeatureBanner = useAppSelector(
        getShowCrmIntegrationFeatureBanner,
    );
    const showNotificationsGrantedBanner = useAppSelector(
        getShowNotificationsGrantedBanner,
    );

    const audioInitiated = useAppSelector((state) =>
        state.app.get('audioInitiated'),
    );

    const defaultTab = calculateSelectedTab(location);
    const entityKey = location.pathname.split('/')[2];

    const showSettingsOnBehalfNotifier =
        defaultTab === 'settings' &&
        isExtensionKey(entityKey) &&
        entityKey !== ownExtensionKey;

    return (
        <>
            {showCrmIntegrationFeatureBanner && <CrmFeatureNotifier />}
            {showNotificationsGrantedBanner && (
                <NotificationPermissionNotifier />
            )}
            {audioInitiated === false && !isMobileApp(embedded) && (
                <UnableToPlayAudioNotifier />
            )}
            <NetworkLostNotifier />
            <CompanionRoleLostNotifier />
            <UpdateNotifier />
            <MicPermissionNotifier />
            <CompanionRequiredNotifier />
            <CompanionHeartbeat />
            <GeoLocationNotifier />
            <InstallDesktopAppBanner />
            <Windows10Warning />

            {showSettingsOnBehalfNotifier && (
                <Route
                    path={routes['settings']}
                    component={SettingsOnBehalfNotifier}
                />
            )}

            {!isMobileApp(embedded) &&
                !isTeamsTypeIntegration(embedded) &&
                !showSettingsOnBehalfNotifier && (
                    <Switch>
                        <Route path="/:tab" render={() => <AppToolbar />} />
                    </Switch>
                )}
        </>
    );
};

export default MainHeader;
